module.exports = __webpack_public_path__ + "static/media/alvorada.8590dc74.jpeg";